export interface HttpResponse<T = any> {
	data: T;
	status: number;
	statusText: string;
	headers: Record<string, string>;
	config: { method: string; headers: Record<string, string> };
}

export interface HttpRequestConfig {
	params?: Record<string, any>;
	headers?: Record<string, string>;
	signal?: AbortSignal;
	responseType?: 'blob' | 'json' | 'text';
	baseURL?: string;
	paramsSerializer?: (params: any) => string;
}

export class FetchHttpError extends Error {
	response: { status: number; statusText: string; data: any; headers: Record<string, string> };
	status: number;

	constructor(response: Response, data: any) {
		super(`Request failed with status ${response.status}`);
		this.name = 'FetchHttpError';
		this.status = response.status;
		this.response = {
			status: response.status,
			statusText: response.statusText,
			data,
			headers: Object.fromEntries(response.headers.entries()),
		};
	}
}

export interface HttpClient {
	get<T = any, R = HttpResponse<T>>(url: string, config?: HttpRequestConfig): Promise<R>;
	post<T = any, R = HttpResponse<T>>(url: string, data?: any, config?: HttpRequestConfig): Promise<R>;
	put<T = any, R = HttpResponse<T>>(url: string, data?: any, config?: HttpRequestConfig): Promise<R>;
	patch<T = any, R = HttpResponse<T>>(url: string, data?: any, config?: HttpRequestConfig): Promise<R>;
	delete<T = any, R = HttpResponse<T>>(url: string, config?: HttpRequestConfig): Promise<R>;
	defaults: { baseURL: string };
}
